import Link from "@ui-kit/navigation/Link/Link.web";
import Button from "@ui-kit/form/Button/Button.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";

export type HelpAndInfoProps = {
  venueRefundPolicy: string;
};

const HelpAndInfo: React.FC<HelpAndInfoProps> = ({
  venueRefundPolicy,
}): JSX.Element => {
  const { t } = useTranslation("common");

  const faqLinks = [
    {
      id: 0,
      text: t("How do I find my tickets?"),
      url: "https://help.showpass.com/hc/en-us/articles/4406958444439-Frequently-Asked-Questions#how-do-i-find-my-tickets",
    },
    {
      id: 1,
      text: t("Do I have to print my tickets?"),
      url: "https://help.showpass.com/hc/en-us/articles/4406958444439-Frequently-Asked-Questions#do-i-have-to-print-my-tickets",
    },
    {
      id: 2,
      text: t(
        "What if the name on the ticket doesn't match the person who is going to use it?"
      ),
      url: "https://help.showpass.com/hc/en-us/articles/4406958444439-Frequently-Asked-Questions#name-on-ticket-does-not-match",
    },
    {
      id: 3,
      text: t("How do I get a refund?"),
      url: "https://help.showpass.com/hc/en-us/articles/4406958444439-Frequently-Asked-Questions#how-do-i-get-a-refund",
    },
  ];

  return (
    <Flex direction="column">
      <Flex direction="column" mb="2xl">
        <Text fontSize="lg" fontWeight="bold" mb="lg">
          {t("Frequently Asked Questions")}
        </Text>
        <Flex direction="column" gap="sm">
          {faqLinks.map((link) => (
            <Link
              fontWeight="bold"
              data-testid={link.text}
              key={link.id}
              colorPalette="primary"
              variant="underline"
              href={link.url}
              external
              target="_blank"
            >
              {link.text}
            </Link>
          ))}
        </Flex>
      </Flex>
      <Flex direction="column" mb="2xl">
        <Text fontSize="lg" fontWeight="bold" mb="lg">
          {t("Refund Policy")}
        </Text>
        <Text>
          {venueRefundPolicy
            ? t(`${venueRefundPolicy}`)
            : t("This venue hasn't specified a refund policy.")}
        </Text>
      </Flex>

      <Text fontSize="lg" fontWeight="bold" mb="lg">
        {t("Showpass Terms & Privacy Policy")}
      </Text>
      <Flex direction={{ base: "column", xs: "row" }}>
        <Link href="/sell/terms-of-service" external target="_blank" asChild>
          <Button
            as="span"
            data-testid="help-and-info-view-terms"
            variant="outline"
            colorPalette="primary"
          >
            {t("View Terms")}
          </Button>
        </Link>
        <Box mt="none" minWidth="element.lg" minHeight="element.xs" />
        <Link href="/sell/privacy-policy" external target="_blank" asChild>
          <Button
            as="span"
            data-testid="help-and-info-view-privacy-policy"
            variant="outline"
            colorPalette="primary"
          >
            {t("View Privacy Policy")}
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default HelpAndInfo;
